import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../../environments/api-name-list';
import { HttpClientService } from '../../services/http-client-service';

@Injectable()
export class SaeResetPasswordService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    resetPassword(token: string, gibberish: string) {
        const requestObject = {
            token,
            password: gibberish
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.resetGibberish, requestObject);
    }
    resetOktaPassword(userId: any, newPassword: any) {
        const requestObject = {
            userId: userId,
            password: newPassword,
            portal: "university"
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.resetOktaPassword, requestObject);
    }
}
